export enum TimeDurationUnit {
    Hours,
    Minutes,
    Seconds
}

export const TimeFormatInterval = {
    TimeMinutesCssClass: 'time',
    TimeSecondsCssClass: 'time-sec',
    TimeFormatMinutes: 'hh:mm',
    TimeFormatSeconds: 'hh:mm:ss',
    TimeRangeIntervalDefaultMinutes: '00:15:00',
    TimeRangeMinimumMinutes: '00:00',
    TimeRangeMinimumSeconds: '00:00:00',
    TimeRangeMaximum: '24:00:00'
};



// WEBPACK FOOTER //
// ./src/app/shared/timepicker/time-picker-interval.ts